<div class="profile-settings">
    <section class="profile-photo-card">
        <div class="profile-photo-card__image">
            <input id="fileInpt" accept="image/*" (change)="getFile($event)" class="d-none" type="file">
            <img [src]="profileImageSrc" (error)="profileImageSrc = '../../../assets/img/icon_red.png'" alt="profile-img">
            <button
                mat-fab
                class="profile-photo-card__edit"
                type="button"
                (click)="clickFile('fileInpt')"
                matTooltip="Cambiar foto"
            >
                <mat-icon>edit</mat-icon>
            </button>
        </div>
        <div>
            <span>Foto de perfil</span>
            <h2>Actualiza tu imagen</h2>
            <p>Elige una foto clara para identificar tu cuenta dentro de Mindhelp.</p>
        </div>
    </section>

    <form [formGroup]="registerFG" (ngSubmit)="saveForm()" class="profile-form">
        <div class="profile-form__grid">
            <label class="profile-form__field">
                <span>Nombre(s)*</span>
                <mat-form-field appearance="outline">
                    <input matInput formControlName="first_name" required placeholder="Nombre(s)">
                </mat-form-field>
                <div
                    *ngIf="
                    registerFG.controls['first_name'].hasError('minlength') ||
                    registerFG.controls['first_name'].hasError('required') &&
                    registerFG.controls['first_name'].touched"
                    class="error-modal">
                    El nombre debe tener mínimo 3 letras
                </div>
            </label>

            <label class="profile-form__field">
                <span>Apellidos*</span>
                <mat-form-field appearance="outline">
                    <input matInput formControlName="last_name" required placeholder="Apellido">
                </mat-form-field>
                <div
                    *ngIf="
                    registerFG.controls['last_name'].hasError('minlength') ||
                    registerFG.controls['last_name'].hasError('required') &&
                    registerFG.controls['last_name'].touched"
                    class="error-modal">
                    El apellido debe tener mínimo 3 letras
                </div>
            </label>

            <label class="profile-form__field">
                <span>Correo electrónico</span>
                <mat-form-field appearance="outline">
                    <input matInput type="email" formControlName="email" placeholder="Email">
                </mat-form-field>
            </label>

            <label class="profile-form__field">
                <span>Teléfono*</span>
                <mat-form-field appearance="outline">
                    <input matInput type="phone" formControlName="phone_number" required placeholder="Número celular">
                </mat-form-field>
                <div
                    *ngIf="
                    registerFG.controls['phone_number'].hasError('minlength') ||
                    registerFG.controls['phone_number'].hasError('required') &&
                    registerFG.controls['phone_number'].touched"
                    class="error-modal">
                    El teléfono debe tener 10 dígitos.
                </div>
            </label>

            <label class="profile-form__field">
                <span>País*</span>
                <mat-form-field appearance="outline">
                    <mat-select formControlName="country" required placeholder="País">
                        <mat-option value="MX">México</mat-option>
                    </mat-select>
                </mat-form-field>
            </label>

            <label class="profile-form__field">
                <span>Fecha de nacimiento</span>
                <mat-form-field appearance="outline">
                    <input matInput type="date" formControlName="date_of_birth" placeholder="Fecha de Nacimiento" required>
                </mat-form-field>
                <div
                    *ngIf="
                    registerFG.controls['date_of_birth'].hasError('required') &&
                    registerFG.controls['date_of_birth'].touched"
                    class="error-modal">
                    La fecha de nacimiento es obligatoria.
                </div>
            </label>

            <label class="profile-form__field">
                <span>Zona horaria*</span>
                <mat-form-field appearance="outline">
                    <mat-select formControlName="time_zone" required placeholder="Zona horaria">
                        <mat-option *ngFor="let tz of timeZones" [value]="tz">
                            {{ tz }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </label>

            <label class="profile-form__field">
                <span>Género*</span>
                <mat-form-field appearance="outline">
                    <mat-select formControlName="gender" required placeholder="Género">
                        <mat-option value="male">Masculino</mat-option>
                        <mat-option value="female">Femenino</mat-option>
                    </mat-select>
                </mat-form-field>
            </label>
        </div>

        <div class="profile-form__actions">
            <span class="profile-form__hint" *ngIf="!hasProfileChanges">
                Haz un cambio para habilitar el guardado.
            </span>
            <button
                type="submit"
                class="profile-form__submit"
                [disabled]="!hasProfileChanges || registerFG.invalid"
            >
                Guardar cambios
            </button>
        </div>
    </form>
</div>
